import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const campaignCreationSlice = createSlice({
	name: "campaignCreationDisplay",
	initialState: { value: false },
	reducers: {
		updateCampaignCreationDisplay(state, action: PayloadAction<boolean>) {
			state.value = action.payload;
		},
	},
});

export const { updateCampaignCreationDisplay } = campaignCreationSlice.actions;
export default campaignCreationSlice.reducer;